'use strict';

import { anonymousDonorElements } from "./elements/anonymousDonorElements";
import Base from "../Shared/Base";

export const EVENT_TOGGLE_ANONYMOUS_DONOR = 'toggle_anonymous_donor';

export default class AnonymousDonor extends Base
{
    constructor() {
        super();
        this.elements = anonymousDonorElements();
        this.checkboxChange = this.onCheckboxChange.bind(this);
        if (this.elements.isAnonymousCheckbox !== null) {
            this.addEventListeners();
            this.init();
        }
    }

    addEventListeners() {
        this.elements.isAnonymousCheckbox.addEventListener('change', this.checkboxChange);
    }

    init() {
        this.toggleFields(!this.elements.isAnonymousCheckbox.checked);
    }

    toggleFields(show) {
        this.elements.hideOnAnonymous.forEach(element => {
            element.style.display = show ? 'inherit' : 'none';
            const inputFields = this.elements.hiddenInputFields(element);
            inputFields.forEach(inputField => {
                inputField.required = show;
            });
        });
    }

    onCheckboxChange(event) {
        const target = event.currentTarget;
        this.dispatchEvent(new CustomEvent(
            EVENT_TOGGLE_ANONYMOUS_DONOR,
            { detail: { anonymousPayment: target.checked } }
        ));
        this.toggleFields(!target.checked);
    }
}
